// extracted by mini-css-extract-plugin
export default {"menu":"Sidebar_menu__dxY8w","menu__title":"Sidebar_menu__title__YMx5I","wrapper":"Sidebar_wrapper__IBCXN"};